import { useAppModelsStore } from '~/stores/appModelsStore';
// import type { NuxtApp } from '#app'; // Removed problematic import

export default defineNuxtPlugin({
  name: 'app-models-init',
  dependsOn: ['pinia'],
  async setup(nuxtApp) { // Removed NuxtApp type annotation, will be inferred or any
    // Using app:created hook to ensure Pinia is properly initialized
    // nuxtApp is typed as `any` here if type inference doesn't pick up NuxtApp globally.
    // However, the structure of accessing hooks should be fine.
    (nuxtApp as any).hooks.hook('app:created', async () => {
      try {
        // console.log('[app-models-init] app:created hook fired.');
        const appModelsStore = useAppModelsStore(); // Get store instance here, Pinia should be available

        // The fetchModels action uses useFetch, which handles SSR data fetching and client-side hydration.
        // Calling it here ensures data is fetched on the server and available globally.
        // On the client, if data was fetched on SSR, useFetch with the same key should re-use it.
        if (process.server) {
          // console.log('[app-models-init] [Server] Triggering fetchModels within app:created.');
          await appModelsStore.fetchModels();
        } else {
          // On the client, if store is not initialized (e.g. SSR fetch failed or was skipped),
          // fetchModels will be called. Otherwise, hydrated data is used.
          if (!appModelsStore.isInitialized) {
            // console.log('[app-models-init] [Client] Store not initialized within app:created, fetching models.');
            await appModelsStore.fetchModels();
          } else {
            // console.log('[app-models-init] [Client] Store already initialized within app:created.');
          }
        }
      } catch (error) {
        console.error('[app-models-init] Failed to initialize app models store:', error);
        // Don't throw - allow app to continue without models
      }
    });
  },
  // Consider using a hook like 'app:created' if you need to ensure other plugins or Pinia itself is fully set up.
  // For simple store initialization with useFetch, this direct approach in setup is often fine.
}); 